import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams.js';
import { contractsMsg, myProductsAndServicesMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n';
import { isFeatureEnabled } from '../../../../../common/utils/featureFlagUtils.js';
import { HeroHeading, HeroHeadingType } from '../../../../../components/HeroHeading';
import { LocalNavi } from '../../../../../components/LocalNavi';
import { ServiceContracts } from '../../../../../components/SubscriptionLists/ServiceContracts.js';
import { getDisplayCategories } from '../../../../../components/SubscriptionsLayout/SubscriptionsLayout.js';
import { useAuth } from '../../../AuthProvider.js';
import { useConfig } from '../../../ConfigProvider.js';
import type { DefaultListSearchParams } from '../../../../../components/Table';
import type { Contract } from '../../../../../generated/api/contract';

export const ContractsPath = () => {
  const { authenticatedUser } = useAuth();
  const config = useConfig();
  const { search, offset = '0' } = useSearchParams<DefaultListSearchParams>();
  const mobileIdContracts = useLoaderData() as Contract[];

  return (
    <div className="of-subscriptions-scene">
      <HeroHeading
        breadCrumbPaths={[
          { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
          { name: t.SW0J(contractsMsg) },
        ]}
        heroHeadingType={HeroHeadingType.SUBSCRIPTIONS}
        title={t.VWNX(myProductsAndServicesMsg)}
      />
      <LocalNavi categories={getDisplayCategories(config, authenticatedUser?.enabledFeatureFlags)} />
      <ServiceContracts
        offset={Number(offset)}
        search={search}
        mobileIdContracts={mobileIdContracts}
        isMobileIdEnabled={isFeatureEnabled(config.featureFlags.mobileId)}
      />
    </div>
  );
};
